import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _window$CNUI;
import React from "react";
import "./index.scss";
var CnTooltip = (_window$CNUI = window.CNUI) === null || _window$CNUI === void 0 ? void 0 : _window$CNUI.CnTooltip;
/**
 * 自由布局中选择有几列的setter
 * @param props
 * @constructor
 */
var ColumnSelectSetter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ColumnSelectSetter, _React$Component);
  function ColumnSelectSetter(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.select = function (index) {
      var onChange = _this.props.onChange;
      if (typeof index === 'number') {
        _this.originValue = index;
        onChange === null || onChange === void 0 ? void 0 : onChange(index);
      }
    };
    _this.mouseenter = function (index) {
      var onChange = _this.props.onChange;
      _this.setState({
        column: index
      });
      onChange === null || onChange === void 0 ? void 0 : onChange(index);
    };
    _this.mouseleave = function (index) {
      var onChange = _this.props.onChange;
      if (typeof _this.originValue === 'number') {
        onChange === null || onChange === void 0 ? void 0 : onChange(_this.originValue);
      }
    };
    var realValue = Number(_this.props.value);
    _this.state = {
      column: realValue
    };
    _this.originValue = realValue;
    return _this;
  }
  var _proto = ColumnSelectSetter.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        column: Number(nextProps.value)
      });
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var column = this.state.column;
    return /*#__PURE__*/React.createElement("div", {
      onMouseLeave: this.mouseleave,
      className: "cn-column-select-setter"
    }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (item, index) {
      var style = {};
      if (column > index) {
        style.backgroundColor = '#5584ff';
      }
      var dom = /*#__PURE__*/React.createElement("div", {
        onMouseEnter: _this2.mouseenter.bind(_this2, index + 1),
        onClick: _this2.select.bind(_this2, index + 1),
        className: "cn-column-select-setter-item",
        style: style
      });
      if (CnTooltip) {
        return /*#__PURE__*/React.createElement(CnTooltip, {
          trigger: dom
        }, index + 1);
      } else {
        return dom;
      }
    }));
  };
  return ColumnSelectSetter;
}(React.Component);
export { ColumnSelectSetter as default };
ColumnSelectSetter.displayName = 'ColumnSelectSetter';